<template>
  <div
    class="OnOff"
    :class="value?'On':'Off'"
    @click="toggleYesNo"
    :style="{width:width}"
    :disabled="disabled"
  >
    <span class="lblOnOff">
      <div class="OnOffFucus" contenteditable="true" @keydown="onOffFucusKeyDown"></div>
      {{getLabel}}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    value: { type: Boolean, required: true },
    label: { type: String, default: "" },
    width: { type: String },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    toggleYesNo(e) {
      if (e.target.closest("[disabled]")) {
        return;
      }
      this.$emit("input", !this.value);
    },
    onOffFucusKeyDown(e) {
      if (e.which === 9) {
      } else if (
        e.which === 32 ||
        e.which === 13 ||
        e.which === 37 ||
        e.which === 39
      ) {
        this.toggleYesNo(e);
        e.preventDefault();
        e.stopPropagation();
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  },
  computed: {
    getYesNo() {
      return this.value ? "On" : "Off";
    },
    getLabel() {
      if (this.label && this.label.indexOf("|") > 0) {
        let labels = this.label.split("|");
        return this.value ? labels[0] : labels[1];
      } else {
        return "";
      }
    }
  }
};
</script>
<style scoped>
.OnOff {
  background: linear-gradient(
    rgba(255, 255, 255, 0.8),
    rgba(255, 255, 255, 0.2)
  );
  min-width: 60px;
  min-height: 21px;
  padding: 1px;
  border: solid 1px;
  border-radius: 15px;
  display: inline-flex;
  flex-direction: column;
  transition: all 300ms;
  position: relative;
  margin: 1px;
  cursor: default;
}
.OnOff:before {
  content: " ";
  width: 15px;
  height: 15px;

  border: solid 1px rgba(0, 0, 0, 0.9);
  background-image: linear-gradient(
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.2)
  );
  display: block;
  position: absolute;
  border-radius: 10px;
  transition: all 300ms ease-out;
}
.On {
  background-color: green;
  /* align-items: flex-end; */
}
.Off {
  background-color: lightgray;
  /* align-items: flex-start; */
}
.On::before {
  background-color: green;
  left: calc(100% - 18px);
}
.Off::before {
  background-color: rgba(255, 255, 255, 0.5);
  left: 1px;
}
.OnOff .lblOnOff {
  position: absolute;
  color: black;
}
.OnOff.On .lblOnOff {
  left: 5px;
  top: 2px;
}
.OnOff.Off .lblOnOff {
  top: 2px;
  right: 5px;
}
.OnOff:focus-within {
  outline: dotted 1px;
}
.OnOff .OnOffFucus {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
}
[disabled] .OnOff {
  background-color: #ccc;
  color: #222;
  background-image: none;
}
[disabled] .OnOff:before {
  background-color: #ddd;
  color: #222;
  background-image: none;
}

[disabled] .OnOff.On {
  background-color: #8a8;
  color: #222;
  background-image: none;
}
[disabled] .OnOff.On:before {
  background-color: #8b8;
  color: #222;
  background-image: none;
}
</style>


// WEBPACK FOOTER //
// src/components/ekkControls/OnOff.vue